import { c as _c } from "react-compiler-runtime";
import { useCallback, useReducer } from 'react';
import taskDeleteReducer, { initialState } from 'collaboration-sidebar/reducers/taskDelete';
import { MSG_TYPE_CONFIRM_DELETE_TASK, MSG_TYPE_DELETE_TASK, MSG_TYPE_DELETE_TASK_FAILURE, MSG_TYPE_DELETE_TASK_SUCCESS, MSG_TYPE_REQUEST_CLOSE_DELETE_TASK_MODAL, MSG_TYPE_REQUEST_OPEN_DELETE_TASK_MODAL } from 'collaboration-sidebar/constants/IFrameMessageTypes';
export default function useTaskDeleteModal(t0) {
  "use memo";

  const $ = _c(18);
  const {
    sendMessageRef,
    isSendMessageReady
  } = t0;
  const [state, dispatch] = useReducer(taskDeleteReducer, initialState);
  const {
    show,
    taskId
  } = state;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = t2 => {
      const {
        payload
      } = t2;
      bb2: switch (payload.type) {
        case MSG_TYPE_DELETE_TASK_SUCCESS:
        case MSG_TYPE_DELETE_TASK_FAILURE:
          {
            dispatch(payload);
            break bb2;
          }
        case MSG_TYPE_REQUEST_OPEN_DELETE_TASK_MODAL:
          {
            const {
              taskId: payloadTaskId,
              taskName,
              isRepeating
            } = payload;
            dispatch({
              type: MSG_TYPE_REQUEST_OPEN_DELETE_TASK_MODAL,
              taskId: payloadTaskId,
              taskName,
              isRepeating
            });
            break bb2;
          }
        default:
          {
            dispatch(payload);
          }
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleMessage = t1;
  let t2;
  if ($[1] !== show) {
    t2 = () => {
      if (show) {
        dispatch({
          type: MSG_TYPE_REQUEST_CLOSE_DELETE_TASK_MODAL
        });
      }
    };
    $[1] = show;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onClose = t2;
  let t3;
  if ($[3] !== isSendMessageReady || $[4] !== sendMessageRef || $[5] !== show || $[6] !== taskId) {
    t3 = () => {
      if (show && isSendMessageReady && sendMessageRef.current && taskId) {
        sendMessageRef.current(MSG_TYPE_DELETE_TASK, {
          taskId
        });
        dispatch({
          type: MSG_TYPE_CONFIRM_DELETE_TASK
        });
      } else {
        dispatch({
          type: MSG_TYPE_REQUEST_OPEN_DELETE_TASK_MODAL
        });
      }
    };
    $[3] = isSendMessageReady;
    $[4] = sendMessageRef;
    $[5] = show;
    $[6] = taskId;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const onDelete = t3;
  let t4;
  if ($[8] !== isSendMessageReady || $[9] !== sendMessageRef || $[10] !== show || $[11] !== taskId) {
    t4 = t5 => {
      const {
        stopRepeating
      } = t5;
      if (show && isSendMessageReady && sendMessageRef.current && taskId) {
        sendMessageRef.current(MSG_TYPE_DELETE_TASK, {
          taskId,
          stopRepeating
        });
        dispatch({
          type: MSG_TYPE_CONFIRM_DELETE_TASK
        });
      }
    };
    $[8] = isSendMessageReady;
    $[9] = sendMessageRef;
    $[10] = show;
    $[11] = taskId;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const onDecisionMade = t4;
  let t5;
  if ($[13] !== onClose || $[14] !== onDecisionMade || $[15] !== onDelete || $[16] !== state) {
    t5 = Object.assign({}, state, {
      handleMessage,
      onClose,
      onDelete,
      onDecisionMade
    });
    $[13] = onClose;
    $[14] = onDecisionMade;
    $[15] = onDelete;
    $[16] = state;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}